import ShareInStore from "./ShareInStore";

export default ShareInStore;
